import { lazy } from "react";

/**
 * Pages chargées à la demande. Les navigations passent en transition
 * (main.tsx, `v7_startTransition`) : la page affichée reste en place pendant
 * que la suivante se télécharge, et `RouteLoadingOverlay` la voile. Ce petit
 * registre dit s'il y a une page en route.
 */
let pending = 0;
const listeners = new Set<() => void>();

// Un chargement démarre pendant un rendu (initialisation d'un `lazy`) :
// les abonnés sont prévenus juste après, jamais au milieu du rendu.
function notify() {
  queueMicrotask(() => {
    for (const listener of listeners) listener();
  });
}

export const routeLoading = {
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  isLoading: () => pending > 0,
  /** Ouvre un chargement ; la fonction rendue le clôt (une seule fois). */
  begin() {
    pending += 1;
    notify();
    let ended = false;
    return () => {
      if (ended) return;
      ended = true;
      pending -= 1;
      notify();
    };
  },
};

/** `React.lazy` qui signale le téléchargement de la page au registre. */
export const lazyPage: typeof lazy = (load) =>
  lazy(() => {
    const end = routeLoading.begin();
    return load().finally(end);
  });
